import { lazy, Suspense } from 'react';

import useListenSystemThemeChange from 'hooks/useListenSystemThemeChange';
import useMemoSelector from 'hooks/useMemoSelector';

import useChangeColors from 'utils/themes/useChangeColors';

import { getIsDarkModeEnabled } from 'store/selectors/general';
import { PresetContextProvider } from 'services/presets/PresetContext';
import { BatchContextProvider } from './sections/Context';

const BatchEditor = lazy(() => import('./BatchEditor'));

function BatchEditorPage() {
  const darkModeEnabled = useMemoSelector(getIsDarkModeEnabled);

  useChangeColors(darkModeEnabled);
  useListenSystemThemeChange();

  return (
    <Suspense fallback={null}>
      <BatchContextProvider>
        <PresetContextProvider>
          <BatchEditor />
        </PresetContextProvider>
      </BatchContextProvider>
    </Suspense>
  );
}

export default BatchEditorPage;
